import {
  Plug, PanelsTopLeft, Wind, Boxes, Fan, LayoutGrid, Sofa, Dumbbell, Tent,
  Wrench, Sparkles, Shield, SprayCan, Paintbrush, Lightbulb, Lock, Package,
  Image, Blocks, Droplets, Cpu, Thermometer, ShowerHead, Tv, AppWindow
} from "lucide-react";

export const CATEGORIES = ["ALL", "INSTALLATIONS", "REPAIRS", "ASSEMBLY", "HOME CARE"];

// lg spans follow the Tetris grid: every row sums to 12 columns
const SPANS = [
  "lg:col-span-4", "lg:col-span-4", "lg:col-span-4",
  "lg:col-span-8", "lg:col-span-4",
  "lg:col-span-6", "lg:col-span-6",
  "lg:col-span-4", "lg:col-span-4", "lg:col-span-4",
  "lg:col-span-4", "lg:col-span-8",
  "lg:col-span-3", "lg:col-span-5", "lg:col-span-4",
  "lg:col-span-6", "lg:col-span-6",
  "lg:col-span-7", "lg:col-span-5",
  "lg:col-span-4", "lg:col-span-4", "lg:col-span-4",
  "lg:col-span-6", "lg:col-span-6",
  "lg:col-span-12",
];

const RAW = [
  { name: "Appliance Installation", category: "INSTALLATIONS", icon: Plug },
  { name: "Blind Installation", category: "INSTALLATIONS", icon: PanelsTopLeft },
  { name: "Closet & Shelving System Installation", category: "INSTALLATIONS", icon: Boxes },
  { name: "Fan Installation", category: "INSTALLATIONS", icon: Fan },
  { name: "Floor Installation or Replacement", category: "INSTALLATIONS", icon: LayoutGrid },
  { name: "Gazebo Installation & Construction", category: "INSTALLATIONS", icon: Tent },
  { name: "Holiday Lighting Installation", category: "INSTALLATIONS", icon: Sparkles },
  { name: "Lighting Installation", category: "INSTALLATIONS", icon: Lightbulb },
  { name: "Smart Home Installation or Repair", category: "INSTALLATIONS", icon: Cpu },
  { name: "Home Security & Alarms Install", category: "INSTALLATIONS", icon: Shield },
  { name: "Window Treatment Installation or Repair", category: "INSTALLATIONS", icon: AppWindow },
  { name: "Central Air Conditioning Repair", category: "REPAIRS", icon: Wind },
  { name: "Lock Installation & Repair", category: "REPAIRS", icon: Lock },
  { name: "Plumbing", category: "REPAIRS", icon: Droplets },
  { name: "Thermostat Installation or Repair", category: "REPAIRS", icon: Thermometer },
  { name: "Toilet Installation or Replacement", category: "REPAIRS", icon: ShowerHead },
  { name: "Fitness Equipment Assembly", category: "ASSEMBLY", icon: Dumbbell },
  { name: "Furniture Assembly", category: "ASSEMBLY", icon: Sofa },
  { name: "Play Equipment Assembly", category: "ASSEMBLY", icon: Blocks },
  { name: "House Cleaning", category: "HOME CARE", icon: SprayCan },
  { name: "Interior Painting", category: "HOME CARE", icon: Paintbrush },
  { name: "Packing & Unpacking", category: "HOME CARE", icon: Package },
  { name: "TV Mounting", category: "HOME CARE", icon: Tv },
  { name: "Picture Hanging & Art Installation", category: "HOME CARE", icon: Image },
  { name: "General Handyman", category: "HOME CARE", icon: Wrench },
];

export const SERVICES = RAW.map((s, i) => ({
  ...s,
  id: i + 1,
  code: `OP-${String(i + 1).padStart(2, "0")}`,
  span: SPANS[i % SPANS.length],
}));
